<template>
  <v-card>
    <v-card-title
      class="pr-2"
      :style="{ backgroundColor: companyPrimaryColor }"
    >
      <h2 style="color:white">Week doelstelling {{ activeEmployee.name }}</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeBarometerEmployeeDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <v-alert class="ma-0 pa-2" v-if="feedback" :value="true" type="warning">{{
      feedback
    }}</v-alert>

    <v-divider></v-divider>

    <v-card-text>
      <v-form ref="barometerSettingsForm" lazy-validation>
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs6>
              <v-text-field
                label="Doel gemiddelde omzet per uur"
                v-model.number="selectedEmployeeGoal.revenue"
                type="number"
                hint
                dense
                class="mt-4"
                outlined
                :color="companyPrimaryColor"
                background-color="background"
                persistent-hint
                prefix="€"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                label="Doel product verkoop per week"
                v-model.number="selectedEmployeeGoal.producttarget"
                type="number"
                hint
                dense
                class="mt-4"
                outlined
                :color="companyPrimaryColor"
                background-color="background"
                persistent-hint
                prefix="€"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                label="Doel productiviteit"
                v-model.number="selectedEmployeeGoal.productivity"
                type="number"
                hint
                dense
                outlined
                :color="companyPrimaryColor"
                background-color="background"
                persistent-hint
                suffix="%"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                label="Doel aantal producten"
                v-model.number="selectedEmployeeGoal.productsoldtarget"
                type="number"
                hint
                dense
                outlined
                :color="companyPrimaryColor"
                background-color="background"
                persistent-hint
                suffix="producten"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                label="Doel omzet per 4 weken"
                v-model.number="selectedEmployeeGoal.fourweekrevenue"
                type="number"
                hint
                dense
                outlined
                :color="companyPrimaryColor"
                background-color="background"
                persistent-hint
                suffix="euro"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-if="activeCompData.barometersSettings.dyflexis">
              <v-text-field
                label="Dyflexis medewerkernummer"
                v-model.number="selectedEmployeeGoal.dyflexisUserId"
                type="number"
                hint
                dense
                outlined
                :color="companyPrimaryColor"
                background-color="background"
                persistent-hint
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-switch
                class="ma-0 pa-0"
                label="Allround medewerker"
                hide-details
                :color="companyPrimaryColor"
                v-model="selectedEmployeeGoal.allround"
              ></v-switch>
            </v-flex>
            <v-flex xs12>
              <v-switch
                class="ma-0 pa-0"
                label="Medewerker verbergen"
                hide-details
                :color="companyPrimaryColor"
                v-model="selectedEmployeeGoal.hide"
              ></v-switch>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
      <p
        class="pa-0 ma-0"
        style="font-style: italic; color: rgba(0,0,0,0.54); font-size: 12px; padding-left: 8px!important;"
      >
        Alle wijzigingen worden waarneembaar bij het gebruik van de refresh
        knop. (rechtsbovenin)
      </p>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex
            xs12
            md6
            class="text-left"
            v-if="
              $vuetify.breakpoint.name != 'sm' &&
                $vuetify.breakpoint.name != 'xs'
            "
          >
            <v-btn
              outlined
              depressed
              color="#8B93A6"
              @click="closeBarometerEmployeeDialog()"
            >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              :disabled="!changed"
              :depressed="!changed"
              :dark="changed"
              :block="
                $vuetify.breakpoint.name == 'sm' ||
                  $vuetify.breakpoint.name == 'xs'
              "
              rounded
              :color="companySecondaryColor"
              @click="saveSettings()"
            >
              Wijzigingen opslaan
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
import db from "../../firebase/init";
import firebase from "firebase/compat/app";
import lodash from "lodash";
import { bus } from "../../main";
import platform from "platform";

export default {
  name: "edit-barometer-employee-form",
  props: {
    activeEmployee: Object,
    activeCompData: Object,
    selectedEmployeeGoal: Object,
    selectedEmployeeGoalOriginal: Object,
  },
  data() {
    return {
      feedback: null,
      errors: [],
      test: "",
    };
  },

  methods: {
    closeBarometerEmployeeDialog() {
      this.$emit("editBarometerEmployeeDialogChange", false);
      this.feedback = null;
    },

    saveSettings() {
      let benchmarkEmployeesUpdate = {};
      // benchmarkEmployeesUpdate[
      //   (`benchmarkEmployees.${this.activeEmployee.name}.revenue`,
      //   `benchmarkEmployees.${this.activeEmployee.name}.producttarget`)
      // ] = this.selectedEmployeeGoal.revenue;

      if (this.selectedEmployeeGoal.dyflexisUserId) {
        benchmarkEmployeesUpdate[
          `benchmarkEmployees.${this.activeEmployee.id}.dyflexisUserId`
        ] = this.selectedEmployeeGoal.dyflexisUserId;
      }

      if (this.selectedEmployeeGoal.revenue) {
        benchmarkEmployeesUpdate[
          `benchmarkEmployees.${this.activeEmployee.id}.revenue`
        ] = this.selectedEmployeeGoal.revenue;
      }
      if (this.selectedEmployeeGoal.productsoldtarget) {
        benchmarkEmployeesUpdate[
          `benchmarkEmployees.${this.activeEmployee.id}.productsoldtarget`
        ] = this.selectedEmployeeGoal.productsoldtarget;
      }
      if (this.selectedEmployeeGoal.fourweekrevenue) {
        benchmarkEmployeesUpdate[
          `benchmarkEmployees.${this.activeEmployee.id}.fourweekrevenue`
        ] = this.selectedEmployeeGoal.fourweekrevenue;
      }
      if (this.selectedEmployeeGoal.producttarget) {
        benchmarkEmployeesUpdate[
          `benchmarkEmployees.${this.activeEmployee.id}.producttarget`
        ] = this.selectedEmployeeGoal.producttarget;
      }
      if (this.selectedEmployeeGoal.productivity) {
        benchmarkEmployeesUpdate[
          `benchmarkEmployees.${this.activeEmployee.id}.productivity`
        ] = this.selectedEmployeeGoal.productivity;
      }
      if (this.selectedEmployeeGoal.allround) {
        benchmarkEmployeesUpdate[
          `benchmarkEmployees.${this.activeEmployee.id}.allround`
        ] = this.selectedEmployeeGoal.allround;
      }
      if (this.selectedEmployeeGoal.hide) {
        benchmarkEmployeesUpdate[
          `benchmarkEmployees.${this.activeEmployee.id}.hide`
        ] = this.selectedEmployeeGoal.hide;
      }
      benchmarkEmployeesUpdate[
        `benchmarkEmployees.${this.activeEmployee.id}.name`
      ] = this.activeEmployee.name;

      db.collection("companies")
        .doc(this.activeCompData.id)
        .update(benchmarkEmployeesUpdate)
        .then(() => {
          db.collection("log")
            .add({
              time: new Date(),
              logType: "info",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              software: String(platform.os),
              browser: platform.name + " " + platform.version,
              pillarrrVersion: this.$store.state.version,
              action:
                "Barometer medewerker gewijzigd: " +
                this.activeCompData.name +
                " " +
                this.activeEmployee.name,
              extra:
                "<b>ORIGINELE GEGEVENS</b><br> " +
                "<b>Omzet per uur: </b> &euro;" +
                this.selectedEmployeeGoalOriginal.revenue +
                "<br><br>" +
                "<b>AANGEPAST GEGEVENS</b> " +
                "<br>" +
                "<b>Omzet per uur: </b> &euro;" +
                this.selectedEmployeeGoal.revenue,
            })
            .catch((error) => {
              console.error("Error logging barometer settings: ", error);
            });
        })
        .then(() => {
          console.log("Closing");

          this.closeBarometerEmployeeDialog();
        })
        .then(() => {
          console.log("Updating in Dialog");
          // bus.$emit("employeeBarometerUpdate");
          this.$emit("updateData");
        })
        .catch((error) => {
          console.error("Error updating Barometer Employee: ", error);
          db.collection("log").add({
            time: new Date(),
            logType: "error",
            user: this.userFirstName + " " + this.userLastName,
            userType: this.userRole,
            company: this.userCompany,
            actionType: "User Action",
            software: String(platform.os),
            browser: platform.name + " " + platform.version,
            pillarrrVersion: this.$store.state.version,
            action:
              "Error updating Barometer Medewerker: " +
              this.activeCompData.name +
              " " +
              this.activeBranch.branchName,
            extra: JSON.stringify(error),
          });
        });
    },
  },

  computed: {
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    changed() {
      if (
        _.isEqual(
          this.selectedEmployeeGoal,
          this.selectedEmployeeGoalOriginal,
        ) == false
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
